import { registerLocaleData } from '@angular/common';
import skLocale from '@angular/common/locales/sk';
import { bootstrapApplication } from '@angular/platform-browser';
import 'reflect-metadata';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

registerLocaleData(skLocale);

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);
